import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RequestTokenService } from "../../../../../../services/request-token.service";
import { environment } from "../../../../../../environments/environment";
import { PerfilUsuarioSignature } from "../../models/signature/perfilUsuarioSignature";
import { AtualizarSenhaPerfilUsuarioSignature } from "../../models/signature/AtualizarSenhaPerfilUsuarioSignature";
import { AtualizarAtalhoSignature } from "../../models/signature/AtualizarAtalhoSignature";

const API_URL = `${environment.apiUrl}v10/Configuracoes`;

@Injectable({
  providedIn: 'root'
})

export class ConfiguracoesService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  public CarregarListaDeTelas(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/CarregarListaDeTelas`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public CarregarListaAtalhos(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/CarregarListaAtalhos`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public AtualizarTelaAtalho(signature: AtualizarAtalhoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/AtualizarTelaAtalho`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }
 }
